<template lang="pug">
b-modal#manualDeposit(
  ref="manualDeposit"
  :title="$t('ui.manual_deposit')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      .disabled-input.form-control.form-control-sm
        span {{ account_id }}
    b-form-group(:label="$t('ui.amount')").mb-0
      DebounceInput(
        size="sm"
        ref="amount"
        type="text"
        :dirty="$v.amount.$dirty"
        :error="$v.amount.$error"
        v-model.trim.lazy="$v.amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.amount" :name="$t('ui.amount')")
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.submit')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, minValue, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CryptoJS from "crypto-js";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      account_id: "", 
      second_id: "",
      amount: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: { 
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    }
  },
  validations: {
    amount: {
      required,
      decimal,
      minValue: minValue(0)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.depositFTUrl;        
        const md5Key = config.md5KeyProviderFT;

        const timestamp = Date.now();
        const dataString = md5Key + this.item.second_id + timestamp;
        const signature = CryptoJS.MD5(dataString).toString();
        
        var json = {
          userId: this.item.second_id,          
          provider: this.item.actual_code,
          aggregator: this.item.aggregator,
          amount: Math.abs(parseFloat(this.amount) || 0),
          sign: signature,
          ts: timestamp,
          auditBy: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.Status == "string") {
                  this.feedback.success = response.data.Status == "1";
                } else {
                  this.feedback.success = response.data.Status == 1;
                }
                this.feedback.status = response.data.Description;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.manualDeposit.hide();  
                } else {
                  // this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "manual_deposit", this.feedback.status);
                  this.$refs.manualDeposit.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$emit("failed", "manual_deposit", this.feedback.status);
              this.$refs.manualDeposit.hide();
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$emit("failed", "manual_deposit", this.feedback.status);
            this.$refs.manualDeposit.hide();
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.second_id = this.item.second_id;
      this.amount = "";
      this.$refs.amount.$el.focus();
    }
  }
};
</script>

<style scoped>
.disabled-input {
  background-color: #e9ecef;
  opacity: 1;
}
</style>